var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#233737",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 5.51318V8.26688C13.3332 8.64024 13.3332 8.82693 13.4058 8.96954C13.4697 9.09498 13.5717 9.19696 13.6972 9.26088C13.8398 9.33354 14.0265 9.33354 14.3998 9.33354H17.1535M13.3332 15.3335H9.33317M14.6665 12.6668H9.33317M17.3332 10.659V15.4668C17.3332 16.5869 17.3332 17.147 17.1152 17.5748C16.9234 17.9511 16.6175 18.2571 16.2412 18.4488C15.8133 18.6668 15.2533 18.6668 14.1332 18.6668H9.8665C8.7464 18.6668 8.18635 18.6668 7.75852 18.4488C7.3822 18.2571 7.07624 17.9511 6.88449 17.5748C6.6665 17.147 6.6665 16.5869 6.6665 15.4668V8.5335C6.6665 7.41339 6.6665 6.85334 6.88449 6.42551C7.07624 6.04919 7.3822 5.74323 7.75852 5.55148C8.18635 5.3335 8.7464 5.3335 9.8665 5.3335H12.0077C12.4969 5.3335 12.7415 5.3335 12.9716 5.38876C13.1757 5.43775 13.3708 5.51856 13.5497 5.62822C13.7516 5.7519 13.9245 5.92485 14.2704 6.27075L16.3959 8.39624C16.7418 8.74214 16.9148 8.91509 17.0385 9.11693C17.1481 9.29587 17.2289 9.49096 17.2779 9.69503C17.3332 9.92521 17.3332 10.1698 17.3332 10.659Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.73a7a0fbe1c5ff9cfa1cf54d63d7aab7.svg";
export { ForwardRef as ReactComponent };